import { UserQueueSettings } from '../../interfaces/user-queue-settings';
import { LimitOffsetPaging } from '../paged-results/limit-offset-paging.model';

export class ProviderOutboundFaxListSettings {
  filters: null;
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
}

export class ProviderOutboundFaxQueueSettings extends ProviderOutboundFaxListSettings implements UserQueueSettings {
  position: number;
}
